package demos.counter

import androidx.compose.animation.*
import androidx.compose.foundation.layout.*
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp


const val COUNTER_FINAL = "dbec3bb49e26d31627b0cd1a2ca996ad145de8e5"

@OptIn(ExperimentalAnimationApi::class)
@Composable
fun FinalCounter() {

    var count by remember { mutableStateOf(0) }

    Column(
        modifier = Modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {

        CounterButton("+") { count++ }

        Row(
            modifier = Modifier
                .animateContentSize()
                .padding(horizontal = 32.dp),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            count.toString()
//                .reversed()
                .mapIndexed { index, c -> Digit(c, count, index) }
//                .reversed()
                .forEach { digit ->
                    AnimatedContent(
                        targetState = digit,
                        transitionSpec = {
                            if (targetState > initialState) {
                                slideInVertically { -it } with slideOutVertically { it }
                            } else {
                                slideInVertically { it } with slideOutVertically { -it }
                            }
                        }
                    ) { digit ->
                        Text(
                            "${digit.digitChar}",
                            style = MaterialTheme.typography.h3,
                            textAlign = TextAlign.Center,
                        )
                    }
                }
        }

        CounterButton("-") { count-- }
    }

}

data class Digit(val digitChar: Char, val fullNumber: Int, val place: Int) {
    override fun equals(other: Any?): Boolean {
        return when (other) {
            is Digit -> digitChar == other.digitChar
            else -> super.equals(other)
        }
    }
}

operator fun Digit.compareTo(other: Digit): Int {
    return fullNumber.compareTo(other.fullNumber)
}